import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "@/context/LanguageContext";

function fmtError(detail) {
  if (detail == null) return "Anmeldung fehlgeschlagen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("rm_admin_token", data.token);
      navigate("/admin/dashboard");
    } catch (err) {
      setError(fmtError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-anthracite-dark grid-lines-dark px-4" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm border border-white/10 bg-anthracite p-8">
        <div className="flex items-center gap-3">
          <img src="/logo-mark.webp" alt="R-Mechanik Logo" className="h-10 w-auto" />
          <span className="font-black tracking-tight text-white">R-MECHANIK <span className="font-mono-tech text-xs font-normal text-slate-500">ADMIN</span></span>
        </div>
        <div className="mt-8 space-y-4">
          <input type="email" required placeholder="E-Mail" value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full border border-white/15 bg-anthracite-dark px-4 py-3 text-sm text-white outline-none focus:border-royal" data-testid="admin-email" />
          <input type="password" required placeholder="Passwort" value={password} onChange={(e) => setPassword(e.target.value)}
            className="w-full border border-white/15 bg-anthracite-dark px-4 py-3 text-sm text-white outline-none focus:border-royal" data-testid="admin-password" />
          {error && <p className="text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} className="w-full bg-royal px-4 py-3 text-sm font-bold uppercase tracking-wider text-white transition-colors hover:bg-royal-hover disabled:opacity-50" data-testid="admin-login-submit">
            {loading ? "…" : "Anmelden"}
          </button>
        </div>
      </form>
    </div>
  );
}
